import { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Chip,
  Pagination,
  useTheme,
  useMediaQuery,
  Card,
  CardContent,
  Divider,
  TextField,
  Button,
  InputAdornment,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import FilterListIcon from "@mui/icons-material/FilterList";
import FileUploadIcon from "@mui/icons-material/FileUpload";

import {
  Search,
  Sort,
  PlayArrow,
  BarChart,
  Download,
  AccessTime,
  Person,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { palette, theme as colorTheme } from "../../../Convoze.theme";


const primary = colorTheme('palette', 'primary').value;
const primaryBg = colorTheme('palette', 'primaryBg').value;
const positive = colorTheme('palette', 'positive').value;
const negative = colorTheme('palette', 'negative').value;
const neutral = colorTheme('palette', 'neutral').value;


function CallTable({ tableData }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_NIPPON_CONVOZE_AUDIO_PATH;

  const [audioModalOpen, setAudioModalOpen] = useState(false);
  const [selectedAudioUrl, setSelectedAudioUrl] = useState(null);

  const handlePlayAudio = (audioUrl) => {
    setAudioModalOpen(true);
    setSelectedAudioUrl(audioUrl);
  };

  function formatDuration(ms) {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    const paddedMinutes = String(minutes).padStart(2, "0");
    const paddedSeconds = String(seconds).padStart(2, "0");

    return `${paddedMinutes}:${paddedSeconds}`;
  }

  // const ActionButtons = ({ record }) => (
  //   <Box sx={{ display: "flex",  }}>
  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   style={{ color: "#6366F1" }}
  //   class="h-5 w-5"
  //   fill="none"
  //   viewBox="0 0 24 24"
  //   stroke="currentColor"
  //   width="24"
  //   height="24"
  // >
  //   <path
  //     stroke-linecap="round"
  //     stroke-linejoin="round"
  //     stroke-width="2"
  //     d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
  //   ></path>
  //   <path
  //     stroke-linecap="round"
  //     stroke-linejoin="round"
  //     stroke-width="2"
  //     d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  //   ></path>
  // </svg>
  //     {/* <IconButton size="small" sx={{ color: "#6366F1" }} title="Play Recording">
  //       <PlayArrow />
  //     </IconButton> */}
  //     {/* <IconButton size="small" sx={{ color: "#6366F1" }} title="View Analytics">
  //       <BarChart />
  //     </IconButton>
  //     <IconButton size="small" sx={{ color: "#6366F1" }} title="Download">
  //       <Download />
  //     </IconButton> */}
  //   </Box>
  // );

  const ActionButtons = ({ record }) => {
    const hasAudio =
      !!record?.transcriptionId?.audioId?.filePath &&
      record?.transcriptionId?.audioId?.filePath.trim().toUpperCase() !== "N/A";

    return (
      <Box sx={{ display: "flex" }}>
        <Tooltip
          arrow
          title={hasAudio ? "Play Recording" : "No recording available"}
          sx={{
            cursor: "pointer",
          }}
        >
          <span>
            <IconButton
              size="small"
              disabled={!hasAudio}
              onClick={() =>
                hasAudio &&
                handlePlayAudio(record?.transcriptionId?.audioId?.filePath)
              }
              sx={{
                color: {primary},
                "&.Mui-disabled": {
                  color: (theme) => theme.palette.text.disabled,
                  // cursor: "not-allowed",
                },
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style={{ color: "inherit" }}
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </IconButton>
          </span>
        </Tooltip>
      </Box>
    );
  };

  // Mobile Card Component
  const MobileCallCard = ({ record }) => (
    <Card sx={{ mb: 2, border: "1px solid #e0e0e0" }}>
      <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 2,
          }}
        >
          <Box>
            <Typography variant="subtitle2" color="primary" fontWeight="600">
              {record?.dialerId}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {/* {record?.callDate}  */}
              {moment.utc(record?.callDate).format("MMM DD, YYYY")}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {moment.utc(record?.callDate).format("hh:mm A")}
            </Typography>
          </Box>

          <Chip
            label={`${record?.overAllSentiment}`}
            size="small"
            sx={{
              fontWeight: 500,
              bgcolor:
                record?.overAllSentiment == "Positive"
                  ? positive
                  : record?.overAllSentiment == "Neutral"
                    ? neutral
                    : negative,
              color: "#fff",
            }}
          />
        </Box>

        <Box sx={{ mb: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <Person sx={{ fontSize: 16, mr: 1, bgcolor: "text.secondary" }} />
            <Typography variant="body2" fontWeight="500">
              {record?.agentFullName}
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ ml: 3 }}>
            {record?.dialerCustomerName || "NA"}
          </Typography>
        </Box>

        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item size={{ xs: 6 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <AccessTime
                sx={{ fontSize: 16, mr: 1, color: "text.secondary" }}
              />
              <Typography variant="body2">
                {formatDuration(record?.transcriptionId?.callDuration)}
              </Typography>
            </Box>
          </Grid>
          <Grid item size={{ xs: 6 }}>
            <Typography variant="body2" color="text.secondary">
              {record?.callIntent}
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ mb: 2 }} />
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <ActionButtons record={record} />
        </Box>
      </CardContent>
    </Card>
  );

  const getMimeType = (url) => {
    const ext = url?.split(".").pop();
    switch (ext) {
      case "mp3":
        return "audio/mpeg";
      case "wav":
        return "audio/wav";
      case "ogg":
        return "audio/ogg";
      default:
        return "audio/*"; // fallback
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        border: "1px solid #e0e0e0",
        borderRadius: 2,
      }}
    >
      <Box
        sx={{
          mb: 3,
          display: "flex",
          justifyContent: "space-between",
          flexDirection: { xs: "column", md: "row" },
          gap: 1,
        }}
      >
        <Typography
          variant="h6"
          component="h2"
          fontWeight="600"
          color="text.primary"
        >
          Recent Call Recordings
        </Typography>
        {/* <Stack direction="row" spacing={1}>
          <Button
            variant="outlined"
            startIcon={<FilterListIcon />}
            sx={{
              textTransform: "none",
              backgroundColor: "#f5f6f8",
              borderColor: "#f5f6f8",
              color: "#3f3f3f",
              fontWeight: 500,
              "&:hover": {
                backgroundColor: "#e0e0e0",
                borderColor: "#e0e0e0",
              },
            }}
          >
            Filter
          </Button>
          <Button
            variant="outlined"
            startIcon={<FileUploadIcon />}
            sx={{
              textTransform: "none",
              backgroundColor: "#f5f6f8",
              borderColor: "#f5f6f8",
              color: "#3f3f3f",
              fontWeight: 500,
              "&:hover": {
                backgroundColor: "#e0e0e0",
                borderColor: "#e0e0e0",
              },
            }}
          >
            Export
          </Button>
        </Stack> */}
      </Box>
      {!isMobile && (
        <Paper elevation={0} sx={{ borderRadius: 2 }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#fafafa" }}>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      color: "text.secondary",
                      fontSize: "0.75rem",
                    }}
                  >
                    DATE & TIME
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      color: "text.secondary",
                      fontSize: "0.75rem",
                    }}
                  >
                    CALL ID
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      color: "text.secondary",
                      fontSize: "0.75rem",
                    }}
                  >
                    Customer Name
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      color: "text.secondary",
                      fontSize: "0.75rem",
                    }}
                  >
                    DURATION
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      color: "text.secondary",
                      fontSize: "0.75rem",
                    }}
                  >
                    SENTIMENT
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      color: "text.secondary",
                      fontSize: "0.75rem",
                    }}
                  >
                    INTENT
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      color: "text.secondary",
                      fontSize: "0.75rem",
                    }}
                  >
                    ACTIONS
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData?.length == 0 ? (
                  <TableRow sx={{ "&:hover": { backgroundColor: "#f9f9f9" } }}>
                    <TableCell colSpan={7} align="center">
                      <Typography variant="body2" fontWeight="500">
                        No Data Available
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  tableData?.map((record, index) => (
                    <TableRow
                      key={index}
                      sx={{ "&:hover": { backgroundColor: "#f9f9f9" } }}
                    >
                      <TableCell>
                        <Box>
                          <Typography variant="body2" fontWeight="500">
                            {moment
                              .utc(record?.callDate)
                              .format("MMM DD, YYYY")}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {moment.utc(record?.callDate).format("hh:mm A")}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell
                        onClick={() => {
                          navigate(
                            `/user/audio-analytics/${record?.transcriptionId?._id}`
                          );
                        }}
                        sx={{ cursor: "pointer" }}
                      >
                        <Typography
                          variant="body2"
                          color={primary}
                          fontWeight="500"
                        >
                          #{record?.dialerId}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box>
                          <Typography variant="body2" fontWeight="500">
                            {record?.dialerCustomerName || "NA"}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {formatDuration(
                            record?.transcriptionId?.callDuration
                          )}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={`${record?.overAllSentiment}`}
                          size="small"
                          sx={{
                            fontWeight: 500,
                            bgcolor:
                              record?.overAllSentiment === "Positive"
                                ? positive
                                : record?.overAllSentiment === "Neutral"
                                  ? neutral
                                  : negative,
                            color: "#fff",
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" color="text.secondary">
                          {record?.subDisposition
                            ? record?.subDisposition
                            : record?.callIntent || "N/A"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <ActionButtons record={record} />
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}
      {/* Audio Modal */}
      <Dialog
        open={audioModalOpen}
        onClose={() => setAudioModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Call Recording</DialogTitle>
        <DialogContent>
          {selectedAudioUrl ? (
            <audio controls style={{ width: "100%" }}>
              <source
                src={`${baseUrl}/${selectedAudioUrl}`}
                type={getMimeType(selectedAudioUrl)}
              />
              Your browser does not support the audio element.
            </audio>
          ) : (
            <Typography>No audio available</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAudioModalOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Mobile Cards */}
      {isMobile && (
        <Box>
          {tableData?.map((record, index) => (
            <MobileCallCard key={index} record={record} />
          ))}
        </Box>
      )}

      {/* Footer */}
      {tableData?.length > 0 &&
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: 3,
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 2 : 0,
            p: 1,
          }}
        >
          <Typography
            variant="body2"
            color={primary}
            fontWeight={600}
            onClick={() => navigate("/agent/my-calls")}
            sx={{
              cursor: "pointer",
            }}
          >
            View all recordings →
          </Typography>
        </Box>}
    </Paper>
  );
}

export default CallTable;
